import { z } from "zod";

export { mobileOrchestrator } from "@nju/data-access-portal-orchestrator";

export const verificationErrorResponse = z.object({
  code: z.literal("50133"),
});
